export default __webpack_public_path__ + "static/media/cryptocurrency2.6d2a5685.png";